define([
	"dojo/_base/declare",
	"underscore",
	"csi/comm",
	"csi/xml",
	"Apparel/NewStyle",
	"./NewStyleHelper",
	"./CreateColorwaysMixin",
	"./CreateStyleOrCandidateMixin"
], function(declare, _, comm, xml, NewStyle, NewStyleHelper, CreateColorwaysMixin, CreateStyleOrCandidateMixin) {

	var CANDIDATE_QTY = "CandidateQuantity";
	var IS_STYLE_CANDIDATE = "IsStyleCandidate";
	var COLLECTION = "Collection";
	var TEMPLATE = "Template";
	var PRODUCTTYPE = "ProductType";
	var DESCRIPTION = "Description";
	var NUM_OF_DIGITS = 2;

	return declare([NewStyle, CreateColorwaysMixin, CreateStyleOrCandidateMixin], {

		// NewStyleHelper
		helper: null,

		_newStyles: [],

		callModule: "Merchandising",

		addStyleOrCandidateOperation: "AddStyleOrCandidates",

		pushMappingOperation: "PushMappingAttributesToStyleForCreate",

		constructor: function() {
			this.helper = new NewStyleHelper();
		},

		onCreatePopupParams: function(/*Object*/params) {
			// summary: allow controller to add parameters to popup view
			params.bAddHierarchyFields = true;
			var self = this;
			params.onViewStart = function(dfds) {
				dfds.push(self.helper.setFormDefaultValues(this, [self.getParent().$URL], self.getCache()));
			};
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			this._insertCandidateFields(view);
			var mpvNode = this.getParent();
			if (mpvNode != null && mpvNode.Children.length > 0) {
				var self = this;
				var found = _.some(mpvNode.Children, function(option) {
					var optNode = self.getCache().getNode(option);
					return (optNode != null && optNode.Active);
				});
				if (found) {
					this._insertColorwaysField(view);
				}
			}
			this.inherited(arguments);
		},

		process: function() {
			var fd = this.getFormData();
			// no need to set all levels of the hierarchy - only collection
			fd.getFieldValue("ParentSeason", true);
			fd.getFieldValue("Category1", true);
			fd.getFieldValue("Category2", true);
			var fName = fd.getField(xml.ATTR_NAME);
			var name = fd.getFieldValue(xml.ATTR_NAME, true);
			var bStyleAsCandidate = this.getFormData().getFieldValue(IS_STYLE_CANDIDATE, true);
			var styleCandidateQty = this.getFormData().getFieldValue(CANDIDATE_QTY, true);
			var collection = this.getFormData().getFieldValue(COLLECTION, true);
			var styleTemplate = this.getFormData().getFieldValue(TEMPLATE, true);
			var styleType = this.getFormData().getFieldValue(PRODUCTTYPE, true);
			var description = this.getFormData().getFieldValue(DESCRIPTION, true);
			var bCreateColorways = this.getFormData().getFieldValue("CreateColorways", true) || false;
			var w = this.m_writer;
			var usePattern = false;
			var styleName = "";

			if (!bStyleAsCandidate || styleCandidateQty < 1) {
				styleCandidateQty = 1;
			}

			this._productUrls = comm.createUrls(styleCandidateQty);
			this.m_typeNode = "Style";

			if (fName && fName.isDefaultValue() && fName.hasExpression()) {
				// no pattern
			} else if ((styleCandidateQty > 1) && name && (name.indexOf("${0}") < 0)) {
				usePattern = true;
			}

			var styleUrls = [];
			var styleNames = [];

			for (var i = 0; i < styleCandidateQty; ++i) {
				if (usePattern) {
					styleName = "-" + `${i + 1}`.padStart(NUM_OF_DIGITS, "0");
				}

				// add style to list
				styleUrls.push(this._productUrls[i]);
				styleNames.push(styleName);
			}

			const {callModule, addStyleOrCandidateOperation, pushMappingOperation} = this;

			w.callMethod(callModule, addStyleOrCandidateOperation)
				.addParameter(xml.PROP_URL, xml.ATTR_REF, this.getParentURL())
				.addParameter(xml.PROP_NAME, xml.ATTR_STRING, name)
				.addParameter("StyleURLs", xml.ATTR_REFLIST, styleUrls)
				.addParameter("TemplateURL", xml.ATTR_REF, styleTemplate)
				.addParameter("CollectionURL", xml.ATTR_REF, collection)
				.addParameter("StyleTypeURL", xml.ATTR_REF, styleType)
				.addParameter("Description", xml.ATTR_STRING, description)
				.addParameter("NameSuffix", xml.ATTR_STRINGLIST, styleNames)
				.addParameter("StyleAsCandidate", xml.ATTR_BOOLEAN, bStyleAsCandidate)
				.addParameter("CreateColorways", xml.ATTR_BOOLEAN, bCreateColorways);

			w.callMethod(callModule, pushMappingOperation)
				.addParameter("AddURLs", xml.ATTR_REFLIST, [this.getParentURL()])
				.addParameter("StyleURLs", xml.ATTR_REFLIST, styleUrls);

			// Apply changes to Style(s) based on the fields in the form
			this.helper._applyFormFieldsOnStyles(this, styleUrls, styleCandidateQty);

			this.m_typeNode = "MerchProductVersion";

			this._newStyles = styleUrls;
			this.publish();

		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add new url to request
			if (!this._newStyles)
				return this.inherited(arguments);
			return this.inherited(arguments, [urlsNew.concat(this._newStyles)]);
		},

		getNewNodes: function() {
			return this.m_cache.getNodes(this._newStyles);
		}
	});
});
